import { render, staticRenderFns } from "./FileHeader.vue?vue&type=template&id=d677cf20"
import script from "./FileHeader.vue?vue&type=script&lang=js"
export * from "./FileHeader.vue?vue&type=script&lang=js"
import style0 from "./FileHeader.vue?vue&type=style&index=0&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports